<script>
import { GET_PERSONAL_TASK } from "@/core/services/store/tutor/tutor.module";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { toArray, toNumber, toNumberArray } from "../../../../core/filters";
import { getSupplementTutorMockTasks } from "@/core/mock/tutorSupplement.mock";

export default {
  name: "PersonalTaskIndex",
  data() {
    return {
      searchForm: {
        idTask: '',
        taskType: '',
        taskStatus: '',
        tutorType: [],
        handleObject: '',
        doDateRange: [],
        createDateRange: [],
        starRate: []
      },
      taskTypeList: [
        { id: 4, name: 'Gia sư' },
        { id: 5, name: 'Tác vụ khác' }
      ],
      tutorTypeList: [
        { id: 1, label: 'Gia sư đặc biệt' },
        { id: 2, label: 'Gia sư sau khai giảng' },
        { id: 3, label: 'Gia sư lớp đệm' },
        { id: 4, label: 'Gia sư chính sách' },
        { id: 5, label: 'Gia sư quân sự' },
        { id: 6, label: 'Gia sư thi lại' },
        { id: 8, label: 'Gia sư bổ trợ' }
      ],
      statusList: [
        { label: 'Cần làm', value: 0 },
        { label: 'Hoàn thành', value: 1 },
        { label: 'Hủy', value: 2 },
        { label: 'Cần chấm BTVN', value: 3 },
        { label: 'Hoàn thành buổi học', value: 4 },
        { label: 'Cần đánh giá', value: 6 }
      ],
      starList: [
        { name: '1 sao', id: 1 },
        { name: '2 sao', id: 2 },
        { name: '3 sao', id: 3 },
        { name: '4 sao', id: 4 },
        { name: '5 sao', id: 5 }
      ],
      page: 1,
      lastPage: 1,
      total: 0,
      loading: false,
      rows: [],
      timeOutlist: null
    };
  },
  async mounted() {
    await this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Gia sư", route: "" },
      { title: "Tác vụ cá nhân" }
    ]);
    const q = this.$route.query;
    this.page = q?.page ?? 1;
    this.searchForm = {
      idTask: q.id ?? '',
      taskType: toNumber(q.type),
      taskStatus: toNumber(q.status),
      tutorType: toNumberArray(q.subtypes),
      handleObject: q.object_handle ?? '',
      doDateRange: toArray(q.date),
      createDateRange: toArray(q.created_at),
      starRate: toNumberArray(q.starRate) ?? []
    };
    await this.getList();
  },
  methods: {
    clickPage(p) {
      this.page = p;
      this.getList();
    },
    async getList(isFirstPage = false) {
      try {
        this.loading = true;
        const payload = {
          id: this.searchForm.idTask,
          type: this.searchForm.taskType,
          status: this.searchForm.taskStatus,
          subtypes: this.searchForm.taskType === 4 ? this.searchForm.tutorType : null,
          object_handle: this.searchForm.handleObject,
          date: this.searchForm.doDateRange,
          created_at: this.searchForm.createDateRange,
          starRate: this.searchForm.starRate,
          page: isFirstPage ? 1 : this.page
        };
        await this.$router.replace({ query: payload });
        const res = await this.$store.dispatch(GET_PERSONAL_TASK, payload);
        const mockRows = this.filterMockRows(payload);
        this.page = res.pagination.current_page;
        this.total = res.pagination.total + mockRows.length;
        this.lastPage = res.pagination.last_page;
        const apiRows = res.data.map((item) => ({
          id: item.id,
          code: item.id,
          taskTypeName: item.type_label,
          categoryName: item.subtype_label,
          target: item.handler,
          status: item.status,
          workTime: item.work_time,
          assigneeName: item.assignee || "-",
          createdAt: item.created_at,
          rating: item.rating ?? '',
          content: item?.detail?.content,
          detail: item?.detail,
          ...item
        }));
        this.rows = [...mockRows, ...apiRows];
      } catch (e) {

      } finally {
        this.loading = false;
      }
    },
    filterMockRows(payload) {
      const mockRows = getSupplementTutorMockTasks();

      return mockRows.filter((item) => {
        if (payload.type && +payload.type !== 4) {
          return false;
        }

        if (payload.id && !String(item.id).includes(String(payload.id))) {
          return false;
        }

        if (payload.status !== null && payload.status !== undefined && payload.status !== '' && +item.status !== +payload.status) {
          return false;
        }

        if (payload.subtypes && payload.subtypes.length && !payload.subtypes.includes(7)) {
          return false;
        }

        if (payload.object_handle && !String(item.target).toLowerCase().includes(String(payload.object_handle).toLowerCase())) {
          return false;
        }

        if (payload.starRate && payload.starRate.length && !payload.starRate.includes(item.rating)) {
          return false;
        }

        if (payload.created_at && payload.created_at.length === 2) {
          const createdDate = item.createdAt.split(' ')[0].split('/').reverse().join('-');
          if (createdDate < payload.created_at[0] || createdDate > payload.created_at[1]) {
            return false;
          }
        }

        if (payload.date && payload.date.length === 2) {
          const workDate = item.detail.study_date;
          if (workDate < payload.date[0] || workDate > payload.date[1]) {
            return false;
          }
        }

        return true;
      });
    },
    actionMarkHomework(task) {
      this.$router.push({
        name: "mark-homework-v2",
        params: { id: task.detail.classroom_id },
        query: {
          classroom_id: task.detail.classroom_id,
          overall_id: task.detail.overall_id,
          lesson: task.detail.lesson,
          student_id: task.user_id,
          typeReMark: 'remark-tutor',
          isTutor: 1
        }
      });
    },
    statusLabel(val) {
      switch (val) {
        case 0:
          return 'Cần làm';
        case 1:
          return 'Hoàn thành';
        case 2:
          return 'Hủy';
        case 3:
          return 'Cần chấm BTVN';
        case 4:
          return 'Hoàn thành buổi học';
        case 5:
          return 'Cần đánh giá';
        default:
          return '';
      }
    },
    getClassType(type) {
      if (+type === 4) {
        return 'bg-type-tutor';
      }
      if (+type === 5) {
        return 'bg-type-other';
      }
      return '';
    },
    getClassStatus(status) {
      switch (status) {
        case 0:
          return 'bg-status-wait';
        case 1:
          return 'bg-status-success';
        case 2:
          return 'bg-status-cancel';
        case 3:
          return 'bg-status-need';
        case 4:
          return 'bg-status-success-hw';
        case 5:
          return 'bg-status-need-review';
        default:
          return '';
      }
    },
    debounceGetList() {
      if (this.timeOutlist) {
        clearTimeout(this.timeOutlist);
      }
      this.timeOutlist = setTimeout(() => {
        this.getList(true);
        this.timeOutlist = null;
      }, 500);
    }
  }
};
</script>

<template>
  <div class="h-100 pb-5" style="background-color: white">
    <header class="px-5 py-4" style="border-bottom: 1px solid #ccc">
      <h1 style="font-size: 17px;font-weight: 500;margin: 0">Tác vụ cá nhân</h1>
    </header>
    <section>
      <div class="search-box mt-4 row px-5">
        <div class="col-md-3 mb-5">
          <p>Mã tác vụ</p>
          <el-input placeholder="Nhập mã tác vụ" v-model="searchForm.idTask" @input="debounceGetList"></el-input>
        </div>
        <div class="col-md-3">
          <p>Tác vụ</p>
          <el-select v-model="searchForm.taskType" placeholder="Chọn loại tác vụ" class="w-100" clearable @change="debounceGetList">
            <el-option v-for="item in taskTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="col-md-3" v-if="searchForm.taskType === 4">
          <p>Phân loại</p>
          <el-select v-model="searchForm.tutorType" placeholder="Chọn loại gia sư" class="w-100" multiple clearable @change="debounceGetList">
            <el-option v-for="item in tutorTypeList" :key="item.id" :label="item.label" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="col-md-3">
          <p>Đối tượng xử lý</p>
          <el-input placeholder="Nhập tên lớp" v-model="searchForm.handleObject" @input="debounceGetList"></el-input>
        </div>
        <div class="col-md-3">
          <p>Trạng thái</p>
          <el-select v-model="searchForm.taskStatus" placeholder="Chọn trạng thái" class="w-100" clearable @change="debounceGetList">
            <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="col-md-3">
          <p>Thời gian làm</p>
          <el-date-picker
            @change="debounceGetList"
            v-model="searchForm.doDateRange"
            type="daterange"
            class="w-100"
            range-separator="-"
            start-placeholder="Bắt đầu"
            end-placeholder="Kết thúc"
            clearable
            value-format="yyyy-MM-dd"
            format="dd/MM/yyyy"
          ></el-date-picker>
        </div>
        <div class="col-md-3">
          <p>Thời gian tạo</p>
          <el-date-picker
            @change="debounceGetList"
            v-model="searchForm.createDateRange"
            type="daterange"
            class="w-100"
            range-separator="-"
            start-placeholder="Bắt đầu"
            end-placeholder="Kết thúc"
            value-format="yyyy-MM-dd"
            format="dd/MM/yyyy"
            clearable
          ></el-date-picker>
        </div>
        <div class="col-md-3">
          <p>Đánh giá sao</p>
          <el-select v-model="searchForm.starRate" placeholder="Chọn đánh giá sao" class="w-100" multiple clearable @change="debounceGetList">
            <el-option v-for="item in starList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
      </div>
      <div class="table px-5 mt-4">
        <el-table :data="rows" border size="small" style="width:100%" height="510" lazy v-loading="loading">
          <el-table-column label="Mã tác vụ" prop="code" min-width="100" />
          <el-table-column label="Tác vụ" min-width="120">
            <template slot-scope="scope">
              <span :class="getClassType(scope.row.type)" style="padding: 4px 8px; border-radius: 4px; white-space: nowrap">
                {{ scope.row.taskTypeName }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="Phân loại" prop="categoryName" min-width="140">
            <template slot-scope="scope">
              <span style="word-break: break-word">
                {{ scope.row.categoryName }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="Đối tượng xử lý" prop="target" min-width="120">
            <template slot-scope="scope">
              <span style="word-break: keep-all">{{ scope.row.target }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Nội dung" prop="content" width="150" show-overflow-tooltip>
            <template slot-scope="scope">
              <p class="ellipsis">{{ scope.row?.content }}</p>
            </template>
          </el-table-column>
          <el-table-column label="Trạng thái" prop="status" min-width="150">
            <template slot-scope="scope">
              <p v-if="scope.row.taskTypeName === 'Tác vụ khác'">-</p>
              <span v-else :class="getClassStatus(scope.row.status)" style="padding: 4px 8px; border-radius: 4px; white-space: nowrap">
                {{ statusLabel(scope.row.status) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="Đánh giá sao" prop="rating" min-width="80" />
          <el-table-column label="Thời gian làm" prop="workTime" min-width="180" />
          <el-table-column label="Thời gian tạo" prop="createdAt" min-width="170" />
          <el-table-column label="Hành động" min-width="100">
            <template slot-scope="scope">
              <button
                v-if="scope.row.status === 3 && scope.row.taskTypeName === 'Gia sư'"
                @click="actionMarkHomework(scope.row)"
                class="btn btn-xs btn-icon mr-2 btn-outline-success"
                title="Chấm BTVN"
              >
                <i class="el-icon-edit"></i>
              </button>
              <RouterLink
                v-if="scope.row.taskTypeName === 'Gia sư'"
                class="btn btn-xs btn-icon mr-2 btn-outline-info"
                title="Xem chi tiết"
                :to="{ name: 'tutor-detail-task', params: { id: scope.row.code }, query: { type: 'personal' } }"
              >
                <i class="far fa-eye"></i>
              </RouterLink>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="edu-paginate mx-auto text-center d-flex justify-content-between mt-4">
        <div class="spacer"></div>
        <paginate
          v-model="page"
          :page-count="lastPage"
          :page-range="3"
          :margin-pages="1"
          :click-handler="clickPage"
          :prev-text="'Trước'"
          :next-text="'Sau'"
          :container-class="'pagination b-pagination'"
          :page-link-class="'page-link'"
          :next-link-class="'next-link-item'"
          :prev-link-class="'prev-link-item'"
          :prev-class="'page-link'"
          :next-class="'page-link'"
          :page-class="'page-item'"
        />
        <div class="right-div">Tổng số bản ghi: <span style="color:#0066FF">{{ total }}</span></div>
      </div>
    </section>
  </div>
</template>

<style scoped>
.ellipsis {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.bg-status-success {
  background: #1BC5BD;
  color: white;
}

.bg-status-need {
  background: #7000FF;
  color: white;
}

.bg-status-wait {
  background: #FFC424;
  color: black;
}

.bg-status-success-hw {
  background: #0A51BC;
  color: white;
}

.bg-status-cancel {
  background: #575757CC;
  color: white;
}

.bg-status-need-review {
  background: #FF8A00;
  color: white;
}
</style>
